import React from 'react';
import { Button, Modal } from 'react-bootstrap';

interface ConfirmDeleteCursoProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
  cursoName?: string;
}

export default function ConfirmDeleteCurso({
  show,
  onHide,
  onConfirm,
  cursoName,
}: ConfirmDeleteCursoProps) {
  return (
    <Modal centered show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Confirmar Eliminación</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>
          ¿Estás seguro de que deseas eliminar el curso{' '}
          <strong>{cursoName || 'seleccionado'}</strong>?
        </p>
        <p className='text-muted small'>Esta acción no se puede deshacer.</p>
      </Modal.Body>

      <Modal.Footer>
        <Button variant='secondary' onClick={onHide}>
          Cancelar
        </Button>
        <Button variant='danger' onClick={onConfirm}>
          Eliminar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
